export default __webpack_public_path__ + "static/media/cert2.d1619d81.jpg";